import Page from "../page";
import SearchOrchestrator from "../../components/search/search-orchestrator";

const SearchPage = () => {
  return (
    <Page>
      <SearchOrchestrator />
    </Page>
  );
};

export default SearchPage;
